import { convertEmptyStringToUndefined } from 'services/utils'
import { WithLoginAndRegistrationDates } from 'types/common'
import { APICfg } from '../../api'
import { MembershipRole } from './organizations/types/internal/organization-model'
import { CustomerBase } from './types'

export type Membership = {
  organizationId: number
  organizationName: string
  role: MembershipRole
  budget?: number
  budgetDueDate?: string
  budgetSpent?: number
}

export type APIAccountingITA = { pec: string; sdi: string; vat: string }

export type APICustomerITA = APIAccountingITA & ApiCustomer

export type CustomerITA = APICustomerITA

export type ApiCustomer = CustomerBase &
  WithLoginAndRegistrationDates & {
    externalUserId: string
    address?: string
    promotionalActivitiesConsensus: boolean
    profilingConsensus: boolean
    dataProcessingConsensus: boolean
    phone: string
    phoneVerified: boolean
    email: string
    emailVerified: boolean
    membership: Membership
    organizationNumber?: string
  }

export type Customer = ApiCustomer

export const customerUserParse = (res: ApiCustomer): Customer => res

export const baseCustomerWrite = <T extends CustomerBase>({
  responsibleEmail,
  headQuarters,
  ...rest
}: T) => ({
  ...rest,
  responsibleEmail: convertEmptyStringToUndefined(responsibleEmail),
  businessHeadQuarters: convertEmptyStringToUndefined(headQuarters),
})

export const customerUserWrite = async ({
  address,
  createdAt,
  lastLogin,
  organizationNumber,
  ...rest
}: Customer): Promise<ApiCustomer> => ({
  ...baseCustomerWrite(rest),
  address: convertEmptyStringToUndefined(address),
  organizationNumber: convertEmptyStringToUndefined(organizationNumber),
  createdAt,
  lastLogin,
})

const apiCfg: APICfg = {
  endpoint: 'usercustomer',
  parse: customerUserParse,
  write: customerUserWrite,
}

export default apiCfg
